import { render, staticRenderFns } from "./cdr.vue?vue&type=template&id=673cd908&scoped=true"
import script from "./cdr.vue?vue&type=script&lang=js"
export * from "./cdr.vue?vue&type=script&lang=js"
import style0 from "./cdr.vue?vue&type=style&index=0&id=673cd908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673cd908",
  null
  
)

export default component.exports